import { render } from "./DynamicCalendar.vue?vue&type=template&id=84b27116&ts=true"
import script from "./DynamicCalendar.vue?vue&type=script&lang=ts"
export * from "./DynamicCalendar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicCalendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84b27116"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84b27116', __exports__)) {
    api.reload('84b27116', __exports__)
  }
  
  module.hot.accept("./DynamicCalendar.vue?vue&type=template&id=84b27116&ts=true", () => {
    api.rerender('84b27116', render)
  })

}


export default __exports__